/** @format */

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_SIADASH_BACKEND_URL || 'http://localhost:5000';

/**
 * Update a policy by ID
 */
export const updatePolicy = async (
  policyId: string,
  updateData: Record<string, any>
) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/insurance-policies/${policyId}`,
      updateData
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to update policy');
  }
};

